/**
 * @file Purchase PPD Subscription Cart Item Container.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { deselectSubscription as deselectSubscriptionAction } from '../../actions/ppd-purchase';
import {
  openModal as openModalAction,
  closeModal as closeModalAction,
} from '../../actions/modal-actions';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Button from '../../components/global/Button';
import TrashIcon from '../../components/icons/TrashIcon';
import { formatPriceForDisplay } from '../../util/format-money';
import IdentityAvatarContainer from '../global/identity/IdentityAvatarContainer';
import { AVATAR_SIZE_52 } from '../../constants/avatar-sizes';
import { getAlbumPrice } from '../../util/purchase-album';

class PurchasePpdSubscriptionCartItem extends Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      type: PropTypes.oneOf([PPD_CART_ITEM_TYPES.SUBSCRIPTION]),
      identity: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    deselectSubscription: PropTypes.func,
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
  };

  render() {
    const { cartItem, deselectSubscription, album } = this.props;
    const { selectedIdentity } = cartItem;

    const { identity } = selectedIdentity;

    const price = formatPriceForDisplay(getAlbumPrice(album));

    return (
      <div className="ppd-cart-item py-2 px-1">
        <div className="d-flex">
          <div className="cart-item-image d-flex flex-column align-items-center justify-content-center">
            <IdentityAvatarContainer
              size={AVATAR_SIZE_52}
              identity={identity}
            />
            <span className="mt-1 text-dark">{identity.name}</span>
          </div>

          <div className="cart-item-desc">
            <div className="d-flex flex-column">
              <p className="text-sm text-dark m-0">Photo Pass</p>
              <p className="text-xs text-faded mb-1">
                Includes all Hi-Res Downloads for this person on this event.
              </p>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <p className="text-sm text-bold text-dark mb-0 mr-2">${price}</p>

              <Button
                btnStyle="reset"
                onClick={() => deselectSubscription(selectedIdentity)}
              >
                <TrashIcon size={23} color="#f1524b" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openModal: openModalAction,
  closeModal: closeModalAction,
  deselectSubscription: deselectSubscriptionAction,
};

export { PurchasePpdSubscriptionCartItem as PurchasePpdSubscriptionCartItemComp };

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
)(PurchasePpdSubscriptionCartItem);
